import type {
  CustomerTimelineCallEvent,
  CustomerTimelineCallEventEntry,
} from "@repo/app-types/entities/performanceCustomer";
import { CustomerTimelineRowDetails } from "@repo/ui/customerTimeline/customerTimelineRowDetails";
import {
  IconArrowForwardUp,
  IconPhoneCall,
  IconPhoneOff,
  IconPhoneX,
} from "@tabler/icons-react";
import type { ReactNode } from "react";
import {
  callActivityLabel,
  callFailureReasonLabel,
} from "../../teammatePerformance/callActivityColumns.js";
import {
  buildCustomerTimelineParticipant,
  type InteractionRowParts,
} from "./timelineRowHelpers.js";

/**
 * A voice agent's call with no recording to show, and why, if it failed. It
 * can't be opened: only calls with a recording and texts open the interaction.
 */
export function renderCallEventRow(
  entry: CustomerTimelineCallEventEntry,
): InteractionRowParts {
  const { type, error_code: errorCode } = entry.event;
  const reason =
    errorCode === undefined ? undefined : callFailureReasonLabel[errorCode];
  return {
    icon: callEventIcon[type],
    details: (
      <CustomerTimelineRowDetails
        title={
          reason
            ? `${callActivityLabel[type]} — ${reason}`
            : callActivityLabel[type]
        }
        participants={[buildCustomerTimelineParticipant(entry.teammate)]}
      />
    ),
  };
}

const callEventIcon: Record<CustomerTimelineCallEvent["type"], ReactNode> = {
  call_answered: <IconPhoneCall className="size-4" />,
  call_not_answered: <IconPhoneOff className="size-4" />,
  call_forwarded: <IconArrowForwardUp className="size-4" />,
  call_failed: <IconPhoneX className="size-4" />,
};
